<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div class="chart-container p-20">
      <div
        v-if="mssg"
        class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
      >
        <p class="alert-close mb-0">
          {{ mssg }}
        </p>
      </div>
      <div
        v-else-if="Errormssg"
        class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
      >
        <p class="alert-close mb-0">
          {{ Errormssg }}
        </p>
      </div>
      <form @submit.prevent="onSave">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>{{ $t("logo") }}</label>
              <div class="row" style="align-items: center">
                <div class="col-md-8 mb-2">
                  <img
                    id="output"
                    width="250"
                    height="120"
                    class="mb-2"
                    src="../../assets/images/bizlogo.jpeg"
                    alt="business logo"
                  />
                  <label class="gray4">{{ $t("ur_logo") }}</label>
                </div>
                <div class="col-md-4">
                  <input
                    type="file"
                    accept="image/*"
                    name="image"
                    id="file"
                    @change="loadFile"
                    style="display: none"
                  />
                  <label
                    class="btn btn-primary font-10"
                    for="file"
                    style="cursor: pointer"
                    >{{ $t("change_pic") }}</label
                  >
                </div>
              </div>
            </div>
            <!-- 
        <div class="mb-3">
          <h5>
            <span class="text-primary"> Tracker Link:</span>
            <a
              :href="link"
              target="_blank"
              rel="noopener noreferrer"
              class="gray4"
            >
              {{ link }}
            </a>
          </h5>
        </div> -->

            <div class="form-group">
              <label>{{ $t("biz_name") }}</label>
              <input
                type="text"
                name="company_name"
                v-model="businessname"
                class="form-control"
                required
              />
            </div>

            <div class="form-group">
              <label>{{ $t("biz_add") }}</label>
              <textarea
                rows="4"
                style="resize: none"
                class="form-control"
                name="company_address"
                v-model="businessaddress"
                required
              ></textarea>
            </div>
          </div>

          <div class="col-md-6 col-12">
            <div class="form-group">
              <label>{{ $t("biz_email") }}</label>
              <input
                type="email"
                name="company_email"
                class="form-control"
                v-model="businessemail"
                required
              />
            </div>
            <div class="form-group">
              <label for="InputNumber">{{ $t("phone_num") }}</label>
              <div class="form-group">
                <input class="form-control" type="tel" id="phone_number" />
              </div>
              <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                {{ ErrorPhone }}
              </p>
            </div>
          </div>
        </div>

        <hr class="w-100" />

        <div class="row">
          <div class="col-md-6 col-12">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <p class="font-20 font-weight-bold">PPECB Activation</p>

                <p class="font-14 gray3">Activate your PPECB certification</p>
              </div>
              <div class="d-flex align-items-center col-gap-1">
                <label class="font-14 gray3 text-uppercase">{{ isPPECBEnabled ? $t("on") : $t("off") }}</label>
                <toggle-button
                  :value="isPPECBEnabled"
                  @change="handleToggle"
                  :color="'#6282C4'"
                  sync
                />
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button type="submit" class="btn btn-primary">
            {{ $t("save") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import store from "../../store/index";
import axios from "axios";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "BusinessProfile",
  data() {
    return {
      businessname: "",
      businessemail: "",
      businessImageURL: "",
      businessaddress: "",
      isLoading: true,
      fullPage: true,
      mssg: "",
      Errormssg: "",
      ErrorPhone: "",
      iti: "",
      toggleValue: false,
    };
  },
  mounted() {
    var input = document.querySelector("#phone_number");
    this.iti = intlTelInput(input, {
      separateDialCode: true,
      formatOnDisplay: false,
      utilsScript: utils,
    });
    this.fetchProfile()
      .then(() => {
        this.businessname = this.profile.company.name;
        this.businessemail = this.profile.company.email;
        this.businessaddress = this.profile.company.address;
        this.businessImageURL = this.profile.company.image;
        if (this.businessImageURL) {
          var image = document.getElementById("output");
          image.src = this.profile.company.image;
        }
        var number = "+" + this.profile.company.phone.toString();
        // console.log((number))
        this.iti.setNumber(number);
        // console.log(this.iti, "iti stressing me")
        if (!this.iti.isValidNumber()) {
          number =
            "+" +
            this.profile.company.countryCode.toString() +
            this.profile.company.phone.toString();
          // console.log((number))
          this.iti.setNumber(number);
        }
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg = error.response.data.message;
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  components: {
    Loading,
    ToggleButton,
  },
  computed: {
    ...mapGetters(["businessprofile", "profile"]),
    link() {
      return `https://track.gricd.com/${this.profile.company.uniqueCode}`;
    },
    isPPECBEnabled() {
      return this.profile.company.isPPECBEnabled || false;
    },
  },
  methods: {
    ...mapActions(["fetchProfile", "updateBusinessProfile", "updatePPECB"]),
    loadFile(e) {
      const CLOUDINARY_URL =
        "https://api.cloudinary.com/v1_1/gricd-agroallied-services/upload";
      const CLOUDINARY_UPLOAD_PRESET = "utho1avm";
      var file = e.target.files[0];

      if (file.size <= 1000000) {
        this.isLoading = true;
        var image = document.getElementById("output");
        image.src = URL.createObjectURL(e.target.files[0]);

        var formdata = new FormData();
        formdata.append("file", file);
        formdata.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

        axios({
          url: CLOUDINARY_URL,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: formdata,
        })
          .then((res) => {
            this.isLoading = false;
            this.businessImageURL = res.data.secure_url;
            // console.log(this.businessImageURL);
          })
          .catch((err) => {
            this.isLoading = false;
            console.error(err);
          });
      }
    },
    handleToggle({value}) {
      this.isLoading = true;
      this.updatePPECB({
        isPPECBEnabled: value,
      })
        .then(() => {
          this.fetchProfile().then(() => {
            this.isLoading = false;
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSave() {
      // console.log(number, "number before slice")
      let number = this.iti.getNumber().slice(1);
      // console.log(number, "number after slice")
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = "This phone number is not valid";
      } else {
        this.isLoading = true;
        const updatedbusinessprofile = {
          name: this.businessname,
          email: this.businessemail.toLowerCase(),
          address: this.businessaddress,
          image: this.businessImageURL,
          phone: `${parseInt(number)}`,
        };
        //console.log(updatedbusinessprofile);
        this.updateBusinessProfile(updatedbusinessprofile)
          .then((res) => {
            this.isLoading = false;
            this.mssg = res.data.message;
            setTimeout(() => {
              this.mssg = "";
            }, 4000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg = error.response.data.message;
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
a:hover {
  text-decoration: underline;
  color: #8693a5;
}
.chart-container {
  background-color: "#fff";
  position: relative;

  border-radius: 16px;
  box-shadow: 0px 3px 60px 0px #a3abb91a;
  width: 100%;
  margin: auto;
  height: 100%;
  position: relative;
}
</style>

<i18n>
{
	"en": {
		"biz_add": "Business Address",
		"biz_email": "Business Email",
		"biz_name": "Business Name",
		"biz_prof": "Business Profile",
		"change_pic": "Change Picture",
		"logo": "Logo",
		"phone_num": "Phone Number",
		"ur_logo": "Your Logo will show in generated PDF reports (less than 1MB)"
	},
	"es": {
		"biz_add": "Dirección de Negocios",
		"biz_email": "email de negocios",
		"biz_name": "Nombre del Negocio",
		"biz_prof": "Perfil de trabajo",
		"change_pic": "Cambiar imagen",
		"logo": "logo",
		"phone_num": "Número de teléfono",
		"ur_logo": "Su logotipo se mostrará en los informes PDF generados (menos de 1 MB)"
	},
	"fr": {
		"biz_add": "Adresse de travail",
		"biz_email": "Courriel professionnel",
		"biz_name": "Nom de l'entreprise",
		"biz_prof": "Profil de l'entreprise",
		"change_pic": "Changer la photo",
		"logo": "Logo",
		"phone_num": "Numéro de téléphone",
		"ur_logo": "Votre logo apparaîtra dans les rapports PDF générés (moins de 1 Mo)"
	},
	"sw": {
		"biz_add": "Anwani ya Biashara",
		"biz_email": "Barua pepe ya Biashara",
		"biz_name": "Jina la Biashara",
		"biz_prof": "Profaili ya Biashara",
		"change_pic": "BADILISHA picha",
		"logo": "Alama",
		"phone_num": "Nambari ya simu",
		"ur_logo": "Nembo yako itaonyeshwa katika ripoti za PDF (chini ya MB 1)"
	}
}
</i18n>
